import React from 'react'

interface CrossClientEmptyStateProps {
  message: string
}

export const CrossClientEmptyState: React.FC<CrossClientEmptyStateProps> = ({ message }) => (
  <div className='paragraph-small zocks-text-gray-600 text-center w-100 py-4'>{message}</div>
)
